import { EstadoAPI } from "@/api/estado.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Estado } from "@/models/estado";

const estadoApi = new EstadoAPI();

const getAll = (): AxiosObservable<Estado[]> => {
  return estadoApi.getAll();
};

export default {
  getAll
};
